$(document).ready(function(){

  // include this on page template where map is being used
  // <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBlsOcGI7QWt0TPXXyxS6GVlbA1BpsKG6o"></script>

  //* google map ===================================================*/

  // set variables
  var map_title = 'Kellermeister';
  var map_lat = -34.596937;
  var map_long = 138.907054;
  var map_url = 'https://www.google.com/maps/place/Kellermeister/@-34.5992685,138.8893297,15z/data=!4m8!1m2!3m1!2sKellermeister!3m4!1s0x6ab9e49b98fe6d2d:0xff8a34cf98eca179!8m2!3d-34.5976089!4d138.907139';
  var map_marker_image = '/images/map-marker.svg';

  // initialize map
  var map;
  function map_initialize() {

    // standard map setup
    var
    latlang = new google.maps.LatLng(map_lat, map_long),
    mapOptions = {
      zoom: 14,
      center: new google.maps.LatLng(map_lat, map_long - 0.01),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      panControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      scrollwheel: false,
      disableDefaultUI: true,
      zoomControl: true,
      overviewMapControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL
      }
    };
    map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

    // map marker
    var marker = new google.maps.Marker({
        position: latlang,
        map: map,
        icon: {
          url: map_marker_image,
          size: new google.maps.Size(41, 57),
          scaledSize: new google.maps.Size(41, 57)
        },
        title: map_title,
        url: map_url
    });

    // map styles
    var styles = [
      {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#d3d3d3"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "color": "#808080"
          },
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "visibility": "off"
          },
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#ffffff"
          },
          {
            "weight": 1.8
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#d7d7d7"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#ebebeb"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#a7a7a7"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#efefef"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#696969"
          }
        ]
      },
      {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "visibility": "on"
          },
          {
            "color": "#737373"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#d6d6d6"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {},
      {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      }
    ];

    // set map options
    map.setOptions({styles: styles});

    // marker click event
    google.maps.event.addListener(marker, 'click', function() {
      window.location.href = this.url;
    });

  }

  // if map canvas exists, initialize
  if($('#map-canvas').length>=1){
    map_initialize();
  }

});
